import { z } from 'zod';

export const allowedDomainSettingFormSchema = z.object({
  newDomainInput: z.string(),
});

export const allowedDomainSettingSchema = z.object({
  newDomainInput: z
    .string()
    .min(1, 'Domain cannot be empty')
    .regex(
      /^(www\.)?([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
      'Invalid domain format. Please enter domains like "example.com" or "www.example.com"',
    ),
});

export type IAllowedDomainSettingFormState = z.infer<
  typeof allowedDomainSettingFormSchema
>;
